import api from "./api";

const dailyIntakeService = {
  /**
   * Create a new daily intake entry
   */
  createIntake: async (patientId, intakeData) => {
    try {
      console.log(
        "➕ [createIntake] Creating daily intake for patient:",
        patientId
      );

      const response = await api.post(
        `/v1/patients/${patientId}/daily-intake`,
        intakeData
      );

      console.log("✅ [createIntake] Success!");

      return {
        success: true,
        data: response.data,
      };
    } catch (error) {
      console.error("❌ [createIntake] Error:", error);
      // fieldErrors comes from GlobalExceptionHandler's validation-failure
      // response (e.g. { bloodPressureSystolic: "Systolic BP must be at
      // most 300 mmHg" }) — surfaced separately from the generic message
      // so the form can show exactly which field is wrong and why,
      // instead of just "one or more fields are invalid".
      return {
        success: false,
        message: error.response?.data?.message || "Failed to save daily intake",
        fieldErrors: error.response?.data?.fieldErrors || null,
      };
    }
  },

  /**
   * Get intake history for a patient
   */
  getHistory: async (patientId) => {
    try {
      console.log("📋 [getHistory] Fetching history for patient:", patientId);

      const response = await api.get(
        `/v1/patients/${patientId}/daily-intake/history`
      );

      console.log("✅ [getHistory] Success:", response.data.length, "entries");

      return {
        success: true,
        data: response.data,
      };
    } catch (error) {
      console.error("❌ [getHistory] Error:", error);
      return {
        success: false,
        message:
          error.response?.data?.message || "Failed to fetch intake history",
      };
    }
  },

  /**
   * Get current streak for a patient
   */
  getStreak: async (patientId) => {
    try {
      console.log("🔥 [getStreak] Fetching streak for patient:", patientId);

      const response = await api.get(
        `/v1/patients/${patientId}/daily-intake/streak`
      );

      console.log(
        "✅ [getStreak] Success! Streak:",
        response.data.currentStreak
      );

      return {
        success: true,
        data: response.data,
      };
    } catch (error) {
      console.error("❌ [getStreak] Error:", error);
      return {
        success: false,
        message: error.response?.data?.message || "Failed to fetch streak",
      };
    }
  },

  /**
   * Get a specific intake entry by ID
   */
  getIntakeById: async (patientId, entryId) => {
    try {
      console.log(
        "🔍 [getIntakeById] Fetching entry:",
        entryId,
        "for patient:",
        patientId
      );

      const response = await api.get(
        `/v1/patients/${patientId}/daily-intake/${entryId}`
      );

      console.log("✅ [getIntakeById] Success!");

      return {
        success: true,
        data: response.data,
      };
    } catch (error) {
      console.error("❌ [getIntakeById] Error:", error);
      return {
        success: false,
        message:
          error.response?.data?.message || "Failed to fetch intake entry",
      };
    }
  },

  /**
   * Get alerts for a patient
   */
  getAlerts: async (patientId) => {
    try {
      console.log("⚠️ [getAlerts] Fetching alerts for patient:", patientId);

      const response = await api.get(
        `/v1/patients/${patientId}/daily-intake/alerts`
      );

      console.log("✅ [getAlerts] Success:", response.data.length, "alerts");

      return {
        success: true,
        data: response.data,
      };
    } catch (error) {
      console.error("❌ [getAlerts] Error:", error);
      return {
        success: false,
        message: error.response?.data?.message || "Failed to fetch alerts",
      };
    }
  },

  /**
   * Perform health check for a patient
   */
  healthCheck: async (patientId) => {
    try {
      console.log("🏥 [healthCheck] Checking health for patient:", patientId);

      const response = await api.get(
        `/v1/patients/${patientId}/daily-intake/health`
      );

      console.log("✅ [healthCheck] Success!");

      return {
        success: true,
        data: response.data,
      };
    } catch (error) {
      console.error("❌ [healthCheck] Error:", error);
      return {
        success: false,
        message: error.response?.data?.message || "Health check failed",
      };
    }
  },
};

export default dailyIntakeService;